import licenseModule from '../../license.module';
import template from './licenseOverviewUser.component.html';
import style from './licenseOverviewUser.component.css';

export default licenseModule.component('licenseOverviewUser', {
    template,
    style,
    controller: licenseOverviewUserComponent,
    bindToController: true,
    bindings: {
        appspaceIdSummary: '<'
    }
});
function licenseOverviewUserComponent() {
    var vm = this;
    vm.$onChanges = render;
    vm.elements = [];

    function render(changeObj) {
        if (
            changeObj.appspaceIdSummary.currentValue &&
            changeObj.appspaceIdSummary.currentValue != null
        ) {
            vm.licenseOverviewUserUsages =
                vm.appspaceIdSummary.userLicenseTypes;
        }
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-overview-user/licenseOverviewUser.component.js